import gql from 'graphql-tag';
import { isFunction, isObject, keys, pick } from 'lodash';

export const cloneScenarioElements = (
	project,
	newScenario,
	referenceScenario,
	hooks
) => {
	console.group('cloneScenarioElements');
	let stakes = project.stakes;
	let impactedIndicators = project.indicators;
	let impactedStakeholders = project.stakeholders;
	let impactedRisks = project.risks;

	console.log('referenceScenario', referenceScenario);

	let waiting = [];

	// Stakes
	stakes.forEach((i) => {
		let values = pick(i, ['trend', 'weight', 'enabled']);

		if (referenceScenario) {
			let scenarioSimulationIndex = i.scenarios.findIndex(
				(sc) => sc.scenarioId === referenceScenario.id
			);

			values = {
				...values,
				...pick(i.scenarios[scenarioSimulationIndex], [
					'trend',
					'weight',
					'enabled'
				])
			};
		}

		waiting.push(
			optimisticlyUpdateScenario(
				i,
				'Stake',
				newScenario.id,
				values,
				hooks.updateStakeScenario
			)
		);
	});

	// Constraints
	impactedIndicators.forEach((c) => {
		let values = pick(c, ['trend', 'weight', 'enabled']);

		if (referenceScenario) {
			let scenarioSimulationIndex = c.scenarios.findIndex(
				(sc) => sc.scenarioId === referenceScenario.id
			);

			if (scenarioSimulationIndex > -1)
				values = {
					...values,
					...pick(c.scenarios[scenarioSimulationIndex], [
						'trend',
						'weight',
						'enabled'
					])
				};
		}

		waiting.push(
			optimisticlyUpdateScenario(
				c,
				'Indicator',
				newScenario.id,
				values,
				hooks.updateIndicatorScenario
			)
		);
	});

	// Stakeholders
	impactedStakeholders.forEach((s) => {
		let values = pick(s, ['trend', 'impact', 'x', 'y', 'enabled']);

		if (referenceScenario) {
			let scenarioSimulationIndex = s.scenarios.findIndex(
				(sc) => sc.scenarioId === referenceScenario.id
			);

			if (scenarioSimulationIndex > -1) {
				values = {
					...values,
					...pick(s.scenarios[scenarioSimulationIndex], [
						'trend',
						'impact',
						'x',
						'y',
						'enabled'
					])
				};
			}
		}

		waiting.push(
			optimisticlyUpdateScenario(
				s,
				'Stakeholder',
				newScenario.id,
				values,
				hooks.updateStakeholderScenario
			)
		);
	});

	// Risks
	impactedRisks.forEach((r) => {
		let values = pick(r, ['likelihood', 'impact', 'enabled']);

		if (referenceScenario) {
			let scenarioSimulationIndex = r.scenarios.findIndex(
				(sc) => sc.scenarioId === referenceScenario.id
			);

			if (scenarioSimulationIndex > -1) {
				values = {
					...values,
					...pick(r.scenarios[scenarioSimulationIndex], [
						'likelihood',
						'impact',
						'enabled'
					])
				};
			}
		}

		waiting.push(
			optimisticlyUpdateScenario(
				r,
				'Risk',
				newScenario.id,
				values,
				hooks.updateRiskScenario
			)
		);
	});

	// Fishbone Branchs
	(project.fishboneBranchs || []).forEach((fb) => {
		let values = pick(fb, ['weight', 'enabled']);

		if (referenceScenario) {
			let scenarioSimulationIndex = fb.scenarios.findIndex(
				(sc) => sc.scenarioId === referenceScenario.id
			);

			if (scenarioSimulationIndex > -1)
				values = {
					...values,
					...pick(fb.scenarios[scenarioSimulationIndex], [
						'weight',
						'enabled'
					])
				};
		}

		waiting.push(
			optimisticlyUpdateScenario(
				fb,
				'FishboneBranch',
				newScenario.id,
				values,
				hooks.updateFishboneBranchScenario
			)
		);

		// Fishbone Items
		(fb.items || []).forEach((fi) => {
			let itemValues = pick(fi, ['trend', 'completion', 'weight', 'enabled']);

			if (referenceScenario) {
				let scenarioSimulationIndex = fi.scenarios.findIndex(
					(sc) => sc.scenarioId === referenceScenario.id
				);

				if (scenarioSimulationIndex > -1)
					itemValues = {
						...itemValues,
						...pick(fi.scenarios[scenarioSimulationIndex], [
							'trend',
							'completion',
							'weight',
							'enabled'
						])
					};
			}

			waiting.push(
				optimisticlyUpdateScenario(
					fi,
					'FishboneItem',
					newScenario.id,
					itemValues,
					hooks.updateFishboneItemScenario
				)
			);
		});
	});

	console.groupEnd();
	return Promise.all(waiting);
};

export const cloneScenarioElementsToBaseline = async (
	project: {
		stakes: any[];
		indicators: any[];
		stakeholders: any[];
		risks: any[];
		fishboneBranchs: any[];
	},
	originScenario,
	hooks: {
		updateStake: Function;
		updateIndicator: Function;
		updateStakeholder: Function;
		updateRisk: Function;
		updateFishboneBranch: Function;
		updateFishboneItem: Function;
	}
) => {
	console.log('cloneScenarioElementsToBaseline', project, hooks);

	if (!originScenario) return;

	console.log('originScenario', originScenario);

	let waiting = [];

	// Stakes
	(project.stakes || []).forEach((i) => {
		console.log('Stake', i);
		let values = pick(i, ['trend', 'weight', 'enabled']);

		let scenarioSimulationIndex = i.scenarios.findIndex(
			(sc) => sc.scenarioId === originScenario.id
		);

		values = {
			...values,
			...pick(i.scenarios[scenarioSimulationIndex], [
				'trend',
				'weight',
				'enabled'
			])
		};

		console.log(`updateStake`, i.id, project.stakes, null, values);

		waiting.push(
			hooks.updateStake(i.id, project.stakes, null, values)
		);
	});

	// Constraints
	(project.indicators || []).forEach((c) => {
		let values = pick(c, ['trend', 'weight', 'enabled']);

		let scenarioSimulationIndex = c.scenarios.findIndex(
			(sc) => sc.scenarioId === originScenario.id
		);

		if (scenarioSimulationIndex > -1)
			values = {
				...values,
				...pick(c.scenarios[scenarioSimulationIndex], [
					'trend',
					'weight',
					'enabled'
				])
			};

		waiting.push(
			hooks.updateIndicator(c.id, project.indicators, null, values)
		);
	});

	// Stakeholders
	(project.stakeholders || []).forEach((s) => {
		let values = pick(s, ['trend', 'impact', 'x', 'y', 'enabled']);

		let scenarioSimulationIndex = s.scenarios.findIndex(
			(sc) => sc.scenarioId === originScenario.id
		);

		if (scenarioSimulationIndex > -1)
			values = {
				...values,
				...pick(s.scenarios[scenarioSimulationIndex], [
					'trend',
					'impact',
					'x',
					'y',
					'enabled'
				])
			};

		waiting.push(
			hooks.updateStakeholder(s.id, project.stakeholders, null, values)
		);
	});

	// Risks
	(project.risks || []).forEach((r) => {
		let values = pick(r, ['likelihood', 'impact', 'enabled']);

		let scenarioSimulationIndex = r.scenarios.findIndex(
			(sc) => sc.scenarioId === originScenario.id
		);

		if (scenarioSimulationIndex > -1)
			values = {
				...values,
				...pick(r.scenarios[scenarioSimulationIndex], [
					'likelihood',
					'impact',
					'enabled'
				])
			};

		waiting.push(hooks.updateRisk(r.id, project.risks, null, values));
	});

	// Fishbone Branchs
	(project.fishboneBranchs || []).forEach((fb) => {
		let values = pick(fb, ['weight', 'enabled']);

		let scenarioSimulationIndex = fb.scenarios.findIndex(
			(sc) => sc.scenarioId === originScenario.id
		);

		if (scenarioSimulationIndex > -1)
			values = {
				...values,
				...pick(fb.scenarios[scenarioSimulationIndex], [
					'weight',
					'enabled'
				])
			};

		waiting.push(
			hooks.updateFishboneBranch(
				fb.id,
				project.fishboneBranchs,
				null,
				values
			)
		);

		// Fishbone Items
		(fb.items || []).forEach((fi) => {
			let values = pick(fi, ['trend', 'completion', 'weight', 'enabled']);

			let scenarioSimulationIndex = fi.scenarios.findIndex(
				(sc) => sc.scenarioId === originScenario.id
			);

			if (scenarioSimulationIndex > -1)
				values = {
					...values,
					...pick(fi.scenarios[scenarioSimulationIndex], [
						'trend',
						'completion',
						'weight',
						'enabled'
					])
				};

			waiting.push(
				hooks.updateFishboneItem(fi.id, fb.items, null, values)
			);
		});
	});

	//console.groupEnd();
	await Promise.all(waiting);
};

export const getFragmentFields = (values) => {
	return keys(values)
		.filter((v) => v != 'projectId')
		.join('\n');
};

export const getFieldFunctions = (values) => {
	let fields = {};
	for (let key in values) {
		if (values[key] !== undefined) {
			fields[key] = () =>
				isObject(values[key]) && isFunction(values[key].format)
					? values[key].format('YYYY-MM-DD')
					: values[key];
		}
	}
	return fields;
};

export const getUpdatedObject = (object, scenario, changes) => {
	if (!object) return null;

	let updatedObject = {
		...object,
		...changes
	};

	if (scenario) {
		// Créer une copie du tableau scenarios pour éviter de modifier l'original (potentiellement gelé par Apollo)
		updatedObject.scenarios = Array.isArray(object.scenarios)
			? [...object.scenarios]
			: [];

		// Trouver l'index du scénario existant
		const scenarioIndex = updatedObject.scenarios.findIndex(
			(s) => s.scenarioId === scenario.id
		);

		if (scenarioIndex === -1) {
			// Si le scénario n'existe pas, l'ajouter
			updatedObject.scenarios.push({
				id: `${object.id}-${scenario.id}`,
				scenarioId: scenario.id,
				...changes
			});
		} else {
			// Mettre à jour le scénario existant
			updatedObject.scenarios[scenarioIndex] = {
				...updatedObject.scenarios[scenarioIndex],
				...changes
			};
		}
	}

	return updatedObject;
};

/**
 * Masque un élément dans tous les scénarios sauf le scénario actif
 * @param objectDetails - L'objet créé (stakeholder, stake, etc.)
 * @param objectType - Le type d'objet ('Stakeholder', 'Stake', 'Indicator', 'Risk')
 * @param allScenarios - Tous les scénarios du projet
 * @param activeScenario - Le scénario actif (null pour la baseline)
 * @param updateMethod - La méthode de mise à jour du scénario
 */
export const hideElementInOtherScenarios = async (
	objectDetails: any,
	objectType: string,
	allScenarios: any[],
	activeScenario: any | null,
	updateMethod: Function
) => {
	if (!allScenarios || allScenarios.length === 0) return;

	const activeScenarioId = activeScenario?.id || null;

	// Filtrer les scénarios pour exclure le scénario actif
	const otherScenarios = allScenarios.filter(
		(s) => s.id !== activeScenarioId
	);

	// Pour chaque autre scénario, masquer l'élément (enabled: false)
	const promises = otherScenarios.map((scenario) => {
		const scenarioValues: any = { enabled: false };

		// Ajouter les valeurs par défaut selon le type d'objet
		if (objectType === 'Stakeholder') {
			scenarioValues.x = objectDetails.x || 0;
			scenarioValues.y = objectDetails.y || 0;
			scenarioValues.trend = objectDetails.trend || 'neutral';
			scenarioValues.impact = objectDetails.impact || 'low';
		} else if (objectType === 'Risk') {
			scenarioValues.impact = objectDetails.impact || 1;
			scenarioValues.likelihood = objectDetails.likelihood || 1;
		} else if (objectType === 'Stake' || objectType === 'Indicator') {
			scenarioValues.trend = objectDetails.trend || '50';
		} else if (objectType === 'FishboneItem') {
			scenarioValues.trend = objectDetails.trend || '50';
			scenarioValues.completion = objectDetails.completion || 0;
		} else if (objectType === 'FishboneBranch') {
			// FishboneBranch n'a pas de valeurs spécifiques au scénario
		}

		return optimisticlyUpdateScenario(
			objectDetails,
			objectType,
			scenario.id,
			scenarioValues,
			updateMethod
		);
	});

	await Promise.all(promises);
};

export const optimisticlyUpdateScenario = async (
	objectDetails: any,
	objectType: string,
	scenarioId: string,
	values: any,
	method: Function
) => {
	const { id: objectId } = objectDetails;

	// Ne garder que les champs scénario réellement fournis dans values (pas de merge avec objectDetails)
	const scenarioFieldNames = [
		'trend',
		'x',
		'y',
		'impact',
		'likelihood',
		'completion',
		'weight',
		'enabled'
	];
	const mutationValues: Record<string, any> = {};
	for (const key of scenarioFieldNames) {
		if (values[key] !== undefined) {
			mutationValues[key] = values[key];
		}
	}

	await method({
		variables: { id: objectId, scenarioId, ...mutationValues },
		async update(cache) {
			const cacheKey = `${objectType}ScenarioSimulation:${objectId}-${scenarioId}`;

			let existingFragment = cache.readFragment({
				id: cacheKey,
				fragment: gql`
				fragment Read${objectType}ScenarioSimulationFragment on ${objectType}ScenarioSimulation {
					scenarioId
				}
				`
			});

			if (!existingFragment) {
				// Création : construire les données complètes pour le cache
				// avec fallback sur objectDetails pour les champs manquants.
				// Tous les champs attendus par GetProject doivent être présents,
				// sinon Apollo détecte un cache incomplet et déclenche un refetch réseau.
				const cacheValues = { ...mutationValues };

				if (objectType === 'Stakeholder') {
					if (cacheValues.x === undefined)
						cacheValues.x = objectDetails.x || 0;
					if (cacheValues.y === undefined)
						cacheValues.y = objectDetails.y || 0;
					if (cacheValues.trend === undefined)
						cacheValues.trend = objectDetails.trend || 'neutral';
					if (cacheValues.impact === undefined)
						cacheValues.impact = objectDetails.impact || 'low';
				}

				if (objectType === 'Risk') {
					if (cacheValues.impact === undefined)
						cacheValues.impact = objectDetails.impact || 1;
					if (cacheValues.likelihood === undefined)
						cacheValues.likelihood = objectDetails.likelihood || 1;
				}

				if (objectType === 'Stake' || objectType === 'Indicator') {
					if (cacheValues.trend === undefined)
						cacheValues.trend = objectDetails.trend || '50';
					if (cacheValues.weight === undefined)
						cacheValues.weight = objectDetails.weight || 1;
				}

				if (objectType === 'FishboneBranch') {
					if (cacheValues.weight === undefined)
						cacheValues.weight = objectDetails.weight || 1;
				}

				if (objectType === 'FishboneItem') {
					if (cacheValues.trend === undefined)
						cacheValues.trend = objectDetails.trend || '50';
					if (cacheValues.completion === undefined)
						cacheValues.completion = objectDetails.completion || 0;
					if (cacheValues.weight === undefined)
						cacheValues.weight = objectDetails.weight || 1;
				}

				if (cacheValues.enabled === undefined) {
					cacheValues.enabled = true;
				}

				await cache.modify({
					id: `${objectType}:${objectId}`,
					fields: {
						scenarios(existingScenarios, { readField }) {
							const scenarios = existingScenarios || [];
							const alreadyExists = scenarios.some(
								(ref: any) =>
									readField('scenarioId', ref) === scenarioId
							);
							if (alreadyExists) {
								return scenarios;
							}
							const newScenarioSimulation = cache.writeFragment({
								id: cacheKey,
								data: {
									id: `${objectId}-${scenarioId}`,
									scenarioId,
									...cacheValues,
									__typename: `${objectType}ScenarioSimulation`
								},
								fragment: gql`
									fragment New${objectType}ScenarioSimulationFragment on ${objectType}ScenarioSimulation {
										id
										scenarioId
										enabled
										${objectType === 'Stakeholder' ? 'x\ny\ntrend\nimpact' : ''}
										${objectType === 'Risk' ? 'impact\nlikelihood' : ''}
										${objectType === 'Stake' || objectType === 'Indicator' ? 'trend\nweight' : ''}
										${objectType === 'FishboneBranch' ? 'weight' : ''}
										${objectType === 'FishboneItem' ? 'trend\ncompletion\nweight' : ''}
									}
								`
							});

							return [...scenarios, newScenarioSimulation];
						}
					}
				});
			} else {
				// Mise à jour : ne modifier que les champs fournis dans le cache
				await cache.modify({
					id: cacheKey,
					fields: getFieldFunctions(mutationValues)
				});
			}

			console.groupEnd();
		},

		optimisticResponse: {
			[`update${objectType}Scenario`]: true
		},

		broadcast: true
	});
};
